var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDollarSign = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.535 7.452A3.9 3.9 0 1 0 12 13v-2a1.9 1.9 0 1 1 1.722-2.703Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11a3.9 3.9 0 1 1-3.535 5.548l1.813-.845A1.9 1.9 0 1 0 12 13Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3.2,
  x: 11,
  y: 3,
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3.2,
  x: 11,
  y: 17.8,
  rx: 1
})));
SvgDollarSign.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgDollarSign);
export default ForwardRef;